import { AppDispatch } from '../../data/store';
import { WebSocketSessionInfo } from './webSocketService';
import {
  Passenger,
  PassengerManualClient,
  PassengerManualInternal,
} from '../../data/models/passenger.model';
import { setPassengerEventEmitted } from '../../data/passenger.slice';

export type IPassengerDetail = {
  manual: PassengerManualClient | PassengerManualInternal;
} & Passenger;

enum PassengerEventType {
  ManualPassengerCreated = 'ManualPassengerCreated',
  ManualPassengerUpdated = 'ManualPassengerUpdated',
}

/**
 * Method for handling all Passenger Events
 * @param sessionInfo The webSocketService sessionInfo object. Contains data copied over from the Redux store as needed
 * @param dispatch The Redux store dispatch function
 * @param detailType A string representing the type of event. Must be one of the TripLegEventType enum values
 * @param detail An object containing the event data, in this case a TripLeg
 */
function updatePassenger(
  sessionInfo: WebSocketSessionInfo,
  dispatch: AppDispatch,
  detailType: string,
  detail: IPassengerDetail,
) {
  switch (detailType) {
    case PassengerEventType.ManualPassengerCreated:
    case PassengerEventType.ManualPassengerUpdated:
      dispatch(setPassengerEventEmitted(detail));
      break;
  }
}

export { PassengerEventType, updatePassenger };
